/**
 * Schemes Maker-Checker Types
 * For scheme approval workflow
 */

/**
 * Scheme basic info for dropdown
 */
export interface SchemeBasicInfo {
  id: number;
  scheme_name: string;
  scheme_type?: string;
  start_date?: string;
  end_date?: string;
}

/**
 * Generated report item in the list
 */
export interface SchemeReportItem {
  id: number;
  report_name: string;
  target_title: string | null;
  target_type_name: string | null;
  ledger_type_name: string | null;
  total_users: number;
  processed_users: number;
  total_points: number;
  total_creditpoints: number;
  approve_status: number; // 1=Pending, 2=Approved, 3=Rejected
  approve_status_name: string;
  excel_path: string | null;
  approval_excel_path: string | null;
  created_at?: string;
  updated_at?: string;
}

/**
 * List response for generated reports
 */
export interface SchemeReportsListResponse {
  data: SchemeReportItem[];
}

/**
 * Payload to generate new maker-checker report
 */
export interface GenerateReportPayload {
  report_name: string;
  scheme_config_id: number;
}

/**
 * Payload to approve report with Excel upload
 */
export interface ApproveReportPayload {
  sale_achievement_report_id: number;
  excel_upload: File;
  program_id: number;
}

/**
 * Payload to reject report
 */
export interface RejectReportPayload {
  sale_achievement_report_id: number;
  program_id: number;
}

/**
 * API response for approve/reject actions
 */
export interface ReportActionResponse {
  message: string;
  success?: boolean;
}

/**
 * Approval status types
 */
export enum ApprovalStatus {
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
}

/**
 * Status badge type mapping
 */
export type ApprovalStatusBadgeType = "warning" | "success" | "danger";

/**
 * Get badge type for approval status
 */
export function getApprovalStatusBadgeType(
  status: number,
): ApprovalStatusBadgeType {
  switch (status) {
    case ApprovalStatus.APPROVED:
      return "success";
    case ApprovalStatus.REJECTED:
      return "danger";
    case ApprovalStatus.PENDING:
    default:
      return "warning";
  }
}
